import { useEffect, useState } from "react";
import { api, snapshotData } from "./api";
import { CITIES } from "../data/cities";

export const cityPath = (slug) => `/kunststof-kozijnen-${slug}`;
export const CITY_PATH_RE = /^\/kunststof-kozijnen-([a-z0-9]+(?:-[a-z0-9]+)*)\/?$/;

const cache = {};
const load = (key, url) => {
  if (!cache[key]) {
    cache[key] = api.get(url).then((r) => r.data).catch((e) => { delete cache[key]; return e?.response?.status === 404 ? "missing" : null; });
  }
  return cache[key];
};
export const refreshWerkgebied = () => Object.keys(cache).forEach((k) => delete cache[k]);

// undefined = laden, null = fout, "missing" = bestaat niet of niet gepubliceerd.
const useLoad = (key, url) => {
  const [data, setData] = useState(() => snapshotData(url));
  useEffect(() => {
    let on = true;
    setData(snapshotData(url));
    if (url) load(key, url).then((d) => on && setData(d));
    return () => { on = false; };
  }, [key, url]);
  return data;
};

export const useCities = () => useLoad("list", "/werkgebied");
// Openbare links (footer, homepage): alleen gepubliceerde plaatsen; nooit een vaste lijst, zodat offline plaatsen nergens opduiken.
export const usePublicCityLinks = () => {
  const list = useCities();
  return Array.isArray(list) ? list : [];
};
export const useCityPage = (slug) => useLoad(`c:${slug}`, slug ? `/werkgebied/${slug}` : null);

// Keuzelijst voor beheer (projecten, vragen): vaste plaatsen + nieuwe plaatsen uit Beheer → Werkgebied.
let adminList = null;
export const useAdminCityOptions = () => {
  const [list, setList] = useState(CITIES);
  useEffect(() => {
    let on = true;
    if (!adminList) adminList = api.get("/admin/werkgebied").then((r) => r.data || []).catch(() => { adminList = null; return []; });
    adminList.then((rows) => {
      if (!on) return;
      setList(rows.length ? rows.map((r) => ({ slug: r.slug, name: r.name })) : CITIES);
    });
    return () => { on = false; };
  }, []);
  return list;
};
export const resetAdminCityOptions = () => { adminList = null; };
